<template>
  <div>
    <router-view />
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';

onBeforeMount(() => {
  !(function (doc, win) {
    const [baseWidth, baseHeight] = [1920, 1080];
    const baseRate = baseWidth / baseHeight;
    const docEle = doc.documentElement;
    const resizeFnStr = 'orientationchange' in win ? 'orientationchange' : 'resize';
    const resizeFn = () => {
      const docWidth = docEle.clientWidth;
      const docHeight = docEle.clientHeight;
      const winRate = docWidth / docHeight;
      docEle.style.fontSize = `${(docWidth / baseWidth) * 100}px`;
      // docEle.style.fontSize = `${(baseRate < winRate ? docHeight / baseHeight : docWidth / baseWidth) * 100}px`;
    };
    resizeFn();
    win.addEventListener(resizeFnStr, resizeFn, false);
    doc.addEventListener('DOMContentLoaded', resizeFn, false);
  })(document, window);
});
</script>

<style scoped lang="scss"></style>
